// contexts/ActiveItemContext.js

import { createContext } from 'react';

const ActiveItemContext = createContext();

export default ActiveItemContext;
